/**
 * 兼容 Android 水平滚动的组件
 */
import React, { useEffect, useCallback } from 'react';
import Grounds from '../index';
export const Harizenscroll = ({ children }) => {
    let container;
    const isAndroid = /android/i.test(Grounds.getDeviceInfo().getOs());
    if (!isAndroid)
        return React.createElement("div", null, children);
    const scrollRef = useCallback((node = container) => {
        var _a;
        if (!node)
            return;
        // 兼容 Android 初始化 webview 时没有宽度的问题
        if (document.body.clientWidth < 0) {
            setTimeout(() => {
                scrollRef(node);
            }, 500);
        }
        container = node;
        const boundingClientRect = node.getBoundingClientRect();
        const start = boundingClientRect.top;
        const end = boundingClientRect.bottom;
        const totalHeight = window.innerHeight;
        if ((_a = window.grounds) === null || _a === void 0 ? void 0 : _a.setH5PageTouchArea) {
            window.grounds.setH5PageTouchArea(start, end, totalHeight);
        }
    }, []);
    useEffect(() => {
        let handler;
        let lastCall = Date.now();
        let timeout = 500;
        const callback = () => {
            const now = Date.now();
            if (now - lastCall < timeout)
                clearTimeout(handler);
            lastCall = now;
            handler = setTimeout(() => scrollRef(), timeout);
        };
        window.addEventListener('touchmove', callback);
        return () => window.removeEventListener('touchmove', callback);
    }, []);
    return React.createElement("div", { ref: scrollRef }, children);
};
